/* MISHKA Oct 29 (Cart redo): visible line-item property "Delivery" = "Saturday, Nov 7" so the chosen date shows
   under each product in Shopify checkout. Source of truth stays _mk_date ("dd/mm/yyyy |&| Weekday"); _mk_date and
   product_<id> are never written here. Also keeps _mk_date_iso (2026-11-07) + _mk_date_label in sync.
   Gift cards are skipped. No date -> "Delivery" blanked (hidden by Shopify). Quantity is always kept (/cart/change.js by line). */
(() => {
  if (window.MkLineDate) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const SEP = '|&|', KEY = 'Delivery', H = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Mk-Line': '1' };
  const nf = window.fetch.bind(window);
  const M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'], D = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const parse = (v) => { const m = /^(\d{2})\/(\d{2})\/(\d{4})/.exec(String(v || '').split(SEP)[0].trim()); if (!m) return null;
    const d = new Date(Date.UTC(+m[3], +m[2] - 1, +m[1])); if (isNaN(d)) return null;
    return { iso: m[3] + '-' + m[2] + '-' + m[1], label: D[d.getUTCDay()] + ', ' + M[d.getUTCMonth()] + ' ' + d.getUTCDate() }; };
  const api = { changed: false, running: null, again: false };
  const getCart = () => nf(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then((r) => r.json());
  async function run() {
    let cart = await getCart();
    const dt = parse(cart.attributes && cart.attributes._mk_date);
    const a = cart.attributes || {}, setA = {};
    if ((a._mk_date_iso || '') !== (dt ? dt.iso : '')) setA._mk_date_iso = dt ? dt.iso : '';
    if ((a._mk_date_label || '') !== (dt ? dt.label : '')) setA._mk_date_label = dt ? dt.label : '';
    if (Object.keys(setA).length) await nf(root + 'cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ attributes: setA }) });
    for (let guard = 0; guard < 30; guard++) {
      const i = cart.items.findIndex((it) => !it.gift_card && ((it.properties || {})[KEY] || '') !== (dt ? dt.label : ''));
      if (i < 0) break;
      const it = cart.items[i], props = Object.assign({}, it.properties || {});
      props[KEY] = dt ? dt.label : ''; /* Oct 30: Shopify ignores a deleted key (cart/change.js keeps the old value), so blank it; blank props are hidden */
      const r = await nf(root + 'cart/change.js', { method: 'POST', headers: H, body: JSON.stringify({ line: i + 1, quantity: it.quantity, properties: props }) });
      if (!r.ok) break;
      cart = await r.json(); api.changed = true;
    }
    if (api.changed) document.dispatchEvent(new CustomEvent('mk:line-date', { detail: { label: dt && dt.label } }));
    return cart;
  }
  api.sync = () => { if (api.running) { api.again = true; return api.running; }
    api.running = run().catch(() => {}).then(async (c) => { if (api.again) { api.again = false; c = await run().catch(() => {}); } api.running = null; return c; });
    return api.running; };
  let t; const soon = (ms) => { clearTimeout(t); t = setTimeout(api.sync, ms || 500); };
  const RX = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    const p = nf(input, init);
    try { const u = typeof input === 'string' ? input : input && input.url; const h = init && init.headers;
      const ours = h && (h['X-Mk-Line'] || (h.get && h.get('X-Mk-Line')));
      if (u && RX.test(u.split('#')[0]) && !ours) p.then(() => soon(), () => {}); } catch (e) {}
    return p; };
  const xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { try { if (RX.test(String(u))) this.addEventListener('loadend', () => soon()); } catch (e) {} return xo.apply(this, arguments); };
  document.addEventListener('mk:line-date', () => { /* /cart: line keys changed -> refresh once so qty/remove use new keys */
    if (document.getElementById('main-cart') && !document.querySelector('[data-mk-loading]')) location.reload(); });
  window.MkLineDate = api;
  window.addEventListener('pageshow', () => soon(800));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => soon(800)); else soon(800);
})();
